import PropTypes from 'prop-types'
import { useFormContext } from 'react-hook-form'
import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import {
  FormGroupContainer,
  FormLabelStyled,
  FileInputContainer,
  HiddenFileInput,
  FileInputDisplay,
  FileInputButton,
  FileInputText,
  FormTextStyled,
} from '../styled'

export default function FileInput({
  name,
  label,
  placeholder: _placeholder,
  helperText,
  required,
  ...rest
}) {
  const {
    register,
    formState: { errors },
    setValue,
  } = useFormContext()
  const { t, i18n } = useTranslation()
  const [fileName, setFileName] = useState('')
  const isRTL = i18n.language === 'ar'

  useEffect(() => {
    register(name)
  }, [name, register])

  const handleFileChange = (e) => {
    const files = e.target.files
    if (files && files.length > 0) {
      setFileName(files[0].name)
      setValue(name, files, { shouldValidate: true, shouldDirty: true })
    } else {
      setFileName('')
      setValue(name, null, { shouldValidate: true, shouldDirty: true })
    }
  }

  return (
    <FormGroupContainer>
      <FormLabelStyled>
        {label}
        {required && '*'}
      </FormLabelStyled>
      <FileInputContainer>
        <HiddenFileInput
          type="file"
          onChange={handleFileChange}
          disabled={rest.disabled}
          accept={rest.accept}
        />
        <FileInputDisplay disabled={rest.disabled}>
          <FileInputButton type="button" isRTL={isRTL}>
            {t('general.chooseFile')}
          </FileInputButton>
          <FileInputText hasFile={!!fileName}>
            {fileName || t('general.noFileChosen')}
          </FileInputText>
        </FileInputDisplay>
      </FileInputContainer>
      <FormTextStyled isError={!!errors[name]}>
        {errors[name] ? errors[name].message : helperText}
      </FormTextStyled>
    </FormGroupContainer>
  )
}

FileInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  helperText: PropTypes.string,
  required: PropTypes.bool,
}

FileInput.defaultProps = {
  placeholder: '',
  helperText: '',
  required: false,
}
